import {
  IResourcePermissionWithResName,
  groupSharedKey
} from '@/components/resources/tabs/access-restrictions/RestrictionsTab';
import usePermissions from '@/hooks/usePermissions';
import { sortPermissionsArray } from '@/lib/utils';
import { IResource } from '@gettactic/api';
import { useMemo } from 'react';

export const useResourcesPermissions = (resources: IResource[]) => {
  const { permissions, resourceIds, refresh } = usePermissions(
    resources.map((x) => x.id)
  );

  return useMemo(() => {
    let rest: IResourcePermissionWithResName[] = [];
    const shared: IResourcePermissionWithResName[] = [];
    const inGroups: { [groupKey: string]: IResourcePermissionWithResName[] } =
      {};
    const total = resources.length;
    const perms = permissions?.resource_permissions ?? {};
    Object.keys(perms).forEach((id) => {
      perms[id].forEach((perm) => {
        const res = resources.find((x) => x.id === perm.resource_id);
        const permWithName: IResourcePermissionWithResName = {
          ...perm,
          resName: res?.name ?? '-'
        };
        inGroups[groupSharedKey(perm)] = inGroups[groupSharedKey(perm)] || [];
        inGroups[groupSharedKey(perm)].push(permWithName);
      });
    });
    Object.keys(inGroups).forEach((group) => {
      inGroups[group] = sortPermissionsArray(inGroups[group]);
      if (inGroups[group].length > 0 && inGroups[group].length >= total) {
        // we only save 1 instance
        shared.push(inGroups[group][0]);
      } else {
        rest = rest.concat(inGroups[group]);
      }
    });
    return {
      shared: sortPermissionsArray(shared),
      rest: sortPermissionsArray(rest),
      inGroups,
      refresh
    };
  }, [permissions, resources]);
};
